<template>
  <div class="voluntering-drop-down mt-3">
    <div class="select-voluntering">
      <b-dropdown
          v-model="selectedValue"
          :text="selectedText"
          class="select-voluntering"
      >
        <b-dropdown-item
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            @click="handleClick(option.value)"
        >
          {{ option.text }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileDropdown',
  props: {
    options: {
      type: Array,
    },
    default: {
      type: String,
    },
  },
  data() {
    return {
      selectedValue: this.default,
    };
  },
  methods: {
    handleClick(value) {
      this.$emit('dropdownClicked', value, true);
      this.selectedValue = value;
    },
  },
  computed: {
    selectedText() {
      const option = this.options.find((o) => o.value === this.selectedValue);
      return option ? option.text : '';
    },
  },
};
</script>

<style lang="scss" scoped>
 .voluntering-drop-down {
    .select-voluntering {
      position: relative;
      width: 240px;
      /deep/button {
        position: relative;
        background: #fff !important;
        border-radius: 4px;
        border: solid 1px #e2e2e2;
        color: #333;
        min-width: 240px;
        text-align: left;
        font-size: 15px;

        &::after {
          display: none;
        }
        &::before {
          content: "";
          position: absolute;
          width: 17px;
          height: 14px;
          z-index: 9999;
          background-image: url(/img/down-arrow-black.d5c7f9bc.svg);
          background-repeat: no-repeat;
          background-position: center center;
          right: 9px;
          top: 13px;
          background-size: contain;
          transition: transform 0.3s ease-out;
        }
      }
      &.show {
        /deep/button {
          border-radius: 4px 4px 0 0;
          &::before {
            transition: transform 0.3s ease-out;
            transform: rotate(180deg);
          }
        }
        /deep/.dropdown-menu {
          border-radius: 0 0 4px 4px;
          margin-top: -1px;
        }
      }
      /deep/.dropdown-menu {
        min-width: 240px;
        margin: 0;
        border: solid 1px #e2e2e2;
        font-size: 15px;
      }
      span {
        position: absolute;
        z-index: 999;
        right: 10px;
        top: 5px;
        img {
          width: 15px;
          transition: transform 0.3s ease-out;
        }
      }

      select {
        background: none;
        outline: none;
        border: solid 1px #e2e2e2;

        &:focus {
          box-shadow: none;
          border: solid 1px #e2e2e2;
        }
      }
    }
  }
</style>
